import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { domainRedirectGuard } from './service/guard/domain-redirect.guard';
import { mobiprotektaGuard } from './service/guard/mobiprotekta.guard';
import { redirectGuardService } from './service/guard/redirect-guard.service';

const routes: Routes = [
    {
        path: 'mobiliar',
        canActivate: [domainRedirectGuard, mobiprotektaGuard],
        loadChildren: () =>
            import('./features/osm/mobi/osm.mobi.module').then(m => m.OsmMobiModule),
    },
    {
        path: 'protekta',
        canActivate: [domainRedirectGuard, mobiprotektaGuard],
        loadChildren: () =>
            import('./features/osm/protekta/osm.protekta.module').then(m => m.OsmProtektaModule),
    },
    {
        path: 'accept-code',
        loadChildren: () =>
            import('./features/accept-code/accept-code.module').then(m => m.AcceptCodeModule),
    },
    {
        path: 'mobi',
        redirectTo: 'mobiliar',
    },
    {
        path: 'osm',
        redirectTo: 'mobiliar/osm',
    },
    {
        path: 'public',
        redirectTo: 'mobiliar/public',
    },
    {
        path: 'elevate',
        loadChildren: () => import('./features/elevate/elevate.module').then(m => m.ElevateModule),
    },
    {
        path: 'soon',
        loadChildren: () =>
            import('./features/coming-soon/coming-soon.module').then(m => m.ComingSoonModule),
    },
    {
        path: 'error',
        loadChildren: () => import('./features/error/error.module').then(m => m.ErrorModule),
    },
    {
        path: 'mobi-de',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://www.mobiliar.ch',
        },
    },
    {
        path: 'mobi-fr',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://www.mobiliere.ch',
        },
    },
    {
        path: 'mobi-it',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://www.mobiliare.ch',
        },
    },
    {
        path: 'protekta-de',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://protekta.mobiliar.ch',
        },
    },
    {
        path: 'protekta-fr',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://protekta.mobiliere.ch',
        },
    },
    {
        path: 'protekta-it',
        canActivate: [redirectGuardService],
        component: AppComponent,
        data: {
            externalUrl: 'https://protekta.mobiliare.ch',
        },
    },
    { path: '**', redirectTo: 'mobiliar' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
